/* eslint-disable react/sort-comp */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import { LayoutWithStepper } from 'layouts';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import moment from 'moment';
import validation from 'shared/validations';
import ReactLoading from 'react-loading';
// import { toast } from 'react-toastify';
// import { isEmpty } from 'lodash';
import { isMobileOnly } from 'react-device-detect';
// import OAuthImplicit from 'OAuthImplicit';
// import DocuSign from 'DocuSign';
// import utils from 'shared/helpers/utils';
import {
  stepAction, agreementAction, applicantAction,
  submitClicked, submitInit,
} from 'shared/store/actions';
import selectors from 'shared/store/selectors';
// import arrOptions from 'shared/constant/arrOptions';
import SignatureCanvas from 'react-signature-canvas';
import {
  PATH, FORM_KEYS, APPLICANT_HISTORY_CODE, CLIENT_CLASSIFICATION, QUALIFIED_TYPE_OF_INVESTMENT,
  INVESTMENT_STRATEGY, TYPE_OF_INVESTMENT, ASSET_ALLOCATIONS,
  MUTUAL_FUND_SUBSCRIPTION,
  // SIGNING_STATUS,
} from 'shared/constant';
import {
  FooterAction, TabsMenu, CheckMarkBool,
  FormElementContainer, Label, Button, PageContentWrapper,
} from 'components';
// import { SubPageMenu } from './components';
// import apiRequest from 'shared/services/api';
// import docuconfig from 'DocuConfig';
import { NDPF, PDFViewer, SubPortfolio } from './tabContents';


const factsheetUrl = process.env.REACT_APP_FACTSHEET;
class Agreement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      trimmedDataURL: this.props.signature || null,
      isLoading: false,
      isCanvasEmpty: true,

      // isLoggingInToDocuSign: false,
      // isSendingDocForSigning: false,
      // isWaitingForSignature: false,

      // accessToken: this.props.dsUserDetail?.accessToken || undefined,
      // expires: this.props.dsUserDetail?.expires || undefined,
      // name: this.props.dsUserDetail?.name || undefined,
      // email: this.props.dsUserDetail?.email || undefined,
      // clientUserId: this.props.dsUserDetail?.clientUserId || undefined,
      // externalAccountId: undefined,
      // accountName: undefined,
      // accountId: this.props.dsUserDetail?.accountId || undefined,
      // baseUri: this.props.dsUserDetail?.baseUri || undefined,
      // page: 'loggedIn', // initial page. Pages: welcome|loggedIn
      // working: false,
      // workingMessage: '',
      // responseErrorMsg: undefined,
      // responseEnvelopeId: undefined,
      // responseAvailableApiRequests: undefined,
      // responseApiRequestsReset: undefined,
      // responseSuccess: undefined,
      // responseTraceId: undefined,
      // resultsEnvelopeJson: undefined,
      // // formName: '',
      // // formEmail: '',
      // docPdf: undefined,
      // docName: 'mft',
    };
    // this.oAuthImplicit = new OAuthImplicit(this);
    // this.docusign = new DocuSign(this);
    // this.startAuthentication = this.startAuthentication.bind(this);
    // this.sendEnvelope = this.sendEnvelope.bind(this);
    // this.receiveMessage = this.receiveMessage.bind(this);
  }

  signatureCanvas = {}

  componentDidMount() {
    const {
      onUpdateCurrentStep,
      // intl, onUpdateSteps,
      onLoadProposedAllocationPlan, imarkazRefCode,
      isAllStepsCompleted, history, isShowSubcription, onLoadSubcription,
      investmentStrategies, assetAllocations, onLoadInvestmentStrategyPDFs, onLoadAssetAllocationPDf, onLoadIrepPDF,
      onLoadCpfPDF, typeOfInvestment, clientClassification, onLoadCustomSubPfPDF,
      isCustomAssetAllocationUploaded,
      // onLoadAllCustomUploadedFiles,
      // formSignature, onGetAgreementStatus, clientClassification, isAgreementReadyForQualified,
    } = this.props;

    /** Get Qualified Agreement status */
    // if (formSignature && clientClassification === CLIENT_CLASSIFICATION.QUALIFIED && !isAgreementReadyForQualified) history.push(PATH.QUALIFIED_CONFIRMATION);

    /** Get All uploaded custom files or sub agreements if client classification is Qualified */
    if (clientClassification === CLIENT_CLASSIFICATION.QUALIFIED) onLoadCustomSubPfPDF(); // previoiusly onLoadAllCustomUploadedFiles();

    /** Redirect to Homepage if all steps are completed else update steps */
    if (isAllStepsCompleted) {
      history.push(PATH.HOME);
    } else {
      onUpdateCurrentStep('step5');
    }

    if (clientClassification === CLIENT_CLASSIFICATION.RETAIL && imarkazRefCode) onLoadProposedAllocationPlan();
    if (isShowSubcription) onLoadSubcription();
    if (investmentStrategies.length !== 0) {
      onLoadInvestmentStrategyPDFs();
    }

    if (assetAllocations) {
      if (clientClassification === CLIENT_CLASSIFICATION.QUALIFIED && imarkazRefCode && !isCustomAssetAllocationUploaded) {
        /** if qualified and has imarkaz refcode then load the generated allocation plan by imarkaz */
        onLoadProposedAllocationPlan();
      } else {
        /** Otherwise, load the CUSTOM UPLOADED ASSET ALLOCATION */
        onLoadAssetAllocationPDf();
      }

      /** Load the International Real Estate Product */
      onLoadIrepPDF();
    }
    if (typeOfInvestment === QUALIFIED_TYPE_OF_INVESTMENT.CUSTODY) {
      onLoadCpfPDF();
      onLoadAssetAllocationPDf();
    }
  }

  // componentDidMount() {
  //   const {
  //     onUpdateCurrentStep,
  //     // intl, onUpdateSteps,
  //     onLoadProposedAllocationPlan, imarkazRefCode,
  //     isAllStepsCompleted, history, isShowSubcription, onLoadSubcription,
  //     investmentStrategies, assetAllocations, onLoadInvestmentStrategyPDFs, onLoadAssetAllocationPDf, onLoadIrepPDF,
  //     onLoadCpfPDF, typeOfInvestment, clientClassification, onLoadCustomSubPfPDF,
  //     isCustomAssetAllocationUploaded, ndpfProposedPlanTimestamp, onSaveApplicant,
  //     // onLoadAllCustomUploadedFiles,
  //     // formSignature, onGetAgreementStatus, clientClassification, isAgreementReadyForQualified,
  //   } = this.props;

  //   // await authentication via the new tab (DocuSign)
  //   window.addEventListener('message', this.receiveMessage, false);

  //   /** Redirect to Homepage if all steps are completed else update steps */
  //   if (isAllStepsCompleted) {
  //     history.push(PATH.HOME);
  //   } else {
  //     onUpdateCurrentStep('step5');
  //   }

  //   if (!utils.isCurrentDate(ndpfProposedPlanTimestamp)) {
  //     const timestamp = moment().unix();
  //     const timestampUTC = moment().utcOffset();
  //     this.props.onUpdateTimestamp(timestamp, timestampUTC);

  //     onSaveApplicant(true);
  //   }

  //   /** get pdf documents after 15secs to make sure we get the latest with timestamp */
  //   setTimeout(() => {
  //     /** Get All uploaded custom files or sub agreements if client classification is Qualified */
  //     if (clientClassification === CLIENT_CLASSIFICATION.QUALIFIED) onLoadCustomSubPfPDF(); // previoiusly onLoadAllCustomUploadedFiles();

  //     if (clientClassification === CLIENT_CLASSIFICATION.RETAIL && imarkazRefCode) onLoadProposedAllocationPlan();
  //     if (isShowSubcription) onLoadSubcription();
  //     if (investmentStrategies.length !== 0) {
  //       onLoadInvestmentStrategyPDFs();
  //     }

  //     if (assetAllocations) {
  //       if (clientClassification === CLIENT_CLASSIFICATION.QUALIFIED && imarkazRefCode && !isCustomAssetAllocationUploaded) {
  //         /** if qualified and has imarkaz refcode then load the generated allocation plan by imarkaz */
  //         onLoadProposedAllocationPlan();
  //       } else {
  //         /** Otherwise, load the CUSTOM UPLOADED ASSET ALLOCATION */
  //         onLoadAssetAllocationPDf();
  //       }

  //       /** Load the International Real Estate Product */
  //       onLoadIrepPDF();
  //     }
  //     if (typeOfInvestment === QUALIFIED_TYPE_OF_INVESTMENT.CUSTODY) {
  //       onLoadCpfPDF();
  //       onLoadAssetAllocationPDf();
  //     }
  //   }, 15000);

  //   //  Get Qualified Agreement status
  //   // if (formSignature && clientClassification === CLIENT_CLASSIFICATION.QUALIFIED && !isAgreementReadyForQualified) history.push(PATH.QUALIFIED_CONFIRMATION);
  // }

  /**
     * Receive message from a child .
     * This method is only used if authentication is done
     * in a new tab. See file public/oauthResponse.html
     * @param {object} e
     */
  // async receiveMessage(e) {
  //   const { onUpdateSignature, onSaveApplicant } = this.props;
  //   const rawSource = e && e.data && e.data.source;
  //   const ignore = {
  //     'react-devtools-inject-backend': true,
  //     'react-devtools-content-script': true,
  //     'react-devtools-detector': true,
  //     'react-devtools-bridge': true,
  //   };
  //   const source = (rawSource && !ignore[rawSource]) ? rawSource : false;
  //   if (!source) { return; } // Ignore if no source field
  //   // console.log('SOURCE PostMessage ::', source);
  //   // console.log('??????????>>> ', e.data, e);
  //   if (source === 'dsResponse') {
  //     const { accessToken, responseEnvelopeId } = this.state;
  //     this.docusign.signingCeremonyEnded(e.data);

  //     /** @note check status of the signing docs if signed or not */
  //     const { resultsEnvelopeJson } = await this.docusign.getEnvelope();
  //     // console.log('FROM >>>>>>>>>> ', resultsEnvelopeJson);
  //     // @note save signature info in the store
  //     const params = {
  //       accessToken,
  //       envelopeId: responseEnvelopeId,
  //       status: SIGNING_STATUS.COMPLETE,
  //     };

  //     if (resultsEnvelopeJson.status === 'completed') {
  //       onUpdateSignature(FORM_KEYS.AGREEMENT.NDPF_PROPOSED_PLAN_SIGNATURE, JSON.stringify(params));

  //       // this.setState({ isWaitingForSignature: false });
  //       onSaveApplicant(); // save signature on our backend
  //     }
  //     if (resultsEnvelopeJson.status === 'delivered') {
  //       toast.error('An error has occurred. Please sign the agreement again by clicking the button below. If the button is unresponsive, please refresh the page and try again.');
  //     }
  //     this.setState({ isSendingDocForSigning: false, isWaitingForSignature: false });
  //     return;
  //   }
  //   if (source === 'oauthResponse') {
  //     this.setState({ working: true, workingMessage: 'Logging in' });
  //     const hash = e.data && e.data.hash;
  //     await this.oAuthImplicit.receiveHash(hash);
  //     this.setState({ working: false });
  //   }
  // }

  // startAuthentication() {
  //   this.setState({ isLoggingInToDocuSign: true });
  //   this.oAuthImplicit.startLogin();
  // }

  /**
     * Is the accessToken ok to use?
     * @returns boolean accessTokenIsGood
     */
  // checkToken() {
  //   if (
  //     !this.state.accessToken
  //           || this.state.expires === undefined
  //           || new Date() > this.state.expires
  //   ) {
  //     // Need new login. Only clear auth, don't clear the state (leave form contents);
  //     this.clearAuth();
  //     this.setState({ page: 'welcome', working: false });
  //     toast.error('Your login session has ended.\nPlease login again', {
  //       autoClose: 8000,
  //     });
  //     return false;
  //   }
  //   return true;
  // }

  /**
     * Clear authentication-related state
     */
  // clearAuth() {
  //   this.setState({
  //     accessToken: undefined,
  //     expires: undefined,
  //     accountId: undefined,
  //     externalAccountId: undefined,
  //     accountName: undefined,
  //     baseUri: undefined,
  //     name: undefined,
  //     email: undefined,
  //     clientUserId: undefined,
  //   });
  // }

  /**
     * Clear the app's form and related state
     */
  // clearState() {
  //   this.setState({
  //     // formName: '',
  //     // formEmail: '',
  //     clientUserId: undefined,
  //     working: false,
  //     responseErrorMsg: undefined,
  //     responseEnvelopeId: undefined,
  //     responseAvailableApiRequests: undefined,
  //     responseApiRequestsReset: undefined,
  //     responseSuccess: undefined,
  //     responseTraceId: undefined,
  //     resultsEnvelopeJson: undefined,
  //   });
  // }

  /**
     * Process the oauth results.
     * This method is called by the OAuthImplicit class
     * @param results
     */
  // async oAuthResults(results) {
  //   // get CRM document from api
  //   const { onSaveDsUserInfo } = this.props;
  //   this.setState({
  //     accessToken: results.accessToken,
  //     expires: results.expires,
  //     name: results.name,
  //     clientUserId: results.clientUserId,
  //     externalAccountId: results.externalAccountId,
  //     email: results.email,
  //     accountId: results.accountId,
  //     accountName: results.accountName,
  //     baseUri: results.baseUri,
  //     page: 'loggedIn',
  //     // docPdf: doc,
  //   });

  //   // save user info of logged docuSign user in the store
  //   onSaveDsUserInfo(JSON.stringify({
  //     accessToken: results.accessToken,
  //     expires: results.expires,
  //     name: results.name,
  //     email: results.email,
  //     clientUserId: results.clientUserId,
  //     baseUri: results.baseUri,
  //     accountId: results.accountId,
  //   }));

  //   // toast.success(`Welcome ${results.name}, you are now logged in`); // @Todo we can maybe remmove toaster
  //   this.setState({ isLoggingInToDocuSign: false });
  //   this.sendEnvelope();
  // }

  // async sendEnvelope() {
  //   this.setState({
  //     responseErrorMsg: undefined,
  //     responseEnvelopeId: undefined,
  //     responseAvailableApiRequests: undefined,
  //     responseApiRequestsReset: undefined,
  //     responseSuccess: undefined,
  //     responseTraceId: undefined,
  //     resultsEnvelopeJson: undefined,
  //   });
  //   if (!this.checkToken()) {
  //     return; // Problem! The user needs to login
  //   }

  //   try {
  //     // get Agreement document from api
  //     const { phoneNumber, token, isShowSubcription } = this.props;
  //     const manageproductCode = isShowSubcription ? 'mft' : 'ndpf';
  //     const docName = isShowSubcription ? 'mft' : 'agreement';
  //     const endpoint = `markaz/applicant/pdf/${manageproductCode}`;
  //     const doc = await apiRequest.getPdfDocForDocuSign(endpoint, token, phoneNumber);
  //     if (doc) {
  //       this.setState({
  //         working: true, workingMessage: 'Sending envelope', isSendingDocForSigning: true, docPdf: doc, docName,
  //       });
  //       const results = await this.docusign.sendEnvelope();
  //       const { apiRequestsReset } = results;
  //       const responseApiRequestsReset = apiRequestsReset
  //         ? new Date(apiRequestsReset) : undefined;

  //       this.setState({
  //         working: false,
  //         responseSuccess: results.success,
  //         responseErrorMsg: results.errorMsg,
  //         responseEnvelopeId: results.envelopeId,
  //         responseAvailableApiRequests: results.availableApiRequests,
  //         responseTraceId: results.traceId,
  //         responseApiRequestsReset,
  //       });

  //       // SIGNATURE TIMESTAMP
  //       // const timestamp = moment().unix();
  //       // const timestampUTC = moment().utcOffset();
  //       // this.props.onUpdateTimestamp(timestamp, timestampUTC);

  //       const signer = {
  //         clientUserId: this.state.clientUserId,
  //         name: this.state.name,
  //         email: this.state.email,
  //       };
  //       const objParam = {
  //         envelopeId: results.envelopeId,
  //         signer,
  //         is1stAgreement: false, // for the 2nd agreement
  //       };
  //       await this.docusign.embeddedSigningCeremony(objParam);
  //       // console.log('tesRes docusign ::: ', tesRes);
  //       this.setState({ isSendingDocForSigning: false, isWaitingForSignature: true });
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     this.setState({ isSendingDocForSigning: false, isWaitingForSignature: false });
  //     toast.error('Something went wrong while processing document!'); // @Todo we can maybe remmove toaster
  //   }
  // }

  redoSignature = () => {
    this.setState({ trimmedDataURL: null });
  }

  /** Clear Signature canvass */
  clearSignature = () => {
    this.signatureCanvas.clear();
    this.props.onUpdateSignature(FORM_KEYS.AGREEMENT.NDPF_PROPOSED_PLAN_SIGNATURE, null);
    this.setState({ isCanvasEmpty: true });
  }

  onSubmit = () => {
    // const {
    //   // onUpdateSignature,
    //   onSaveApplicant, history,
    //   // onUpdateTimestamp,
    //   intl,
    //   // ndpf, proposedPlan, signature,
    //   onSendEmail, onSubmitClick, onSubmitInit, onUpdateHistory,
    //   onUpdateSteps,
    //   // isShowSubcription,
    // } = this.props;

    const {
      onUpdateSignature, onSaveApplicant, history, onUpdateTimestamp,
      intl, ndpf, proposedPlan, signature,
      onSendEmail, onSubmitClick, onSubmitInit, onUpdateHistory,
      onUpdateSteps, isShowSubcription,
    } = this.props;

    const isPageValid = validation.contractSchema(intl, isShowSubcription).isValidSync({ ndpf, proposedPlan, ndpfProposedPlanSignature: signature });
    // const isPageValid = validation.contractSchema(intl).isValidSync({ ndpf, proposedPlan, ndpfProposedPlanSignature: signature });
    onSubmitClick();

    // if (isPageValid) {
    // const timestamp = moment().unix();
    // const timestampUTC = moment().utcOffset();
    // onUpdateTimestamp(timestamp, timestampUTC);

    // const generatePDF = true;
    // const signed = true;
    // onSaveApplicant(generatePDF, signed);
    // onSendEmail();
    // onUpdateSteps(intl);
    // onSubmitInit();

    // this.setState({ isLoading: true });
    // setTimeout(() => {
    //   history.push(PATH.PAYMENT);
    //   this.setState({ isLoading: false });
    // }, 5000);
    // }

    // console.log('isPageValid', isPageValid, this.signatureCanvas && this.signatureCanvas.isEmpty());
    if ((this.state.trimmedDataURL === null || this.state.trimmedDataURL === '') && !(this.signatureCanvas && this.signatureCanvas.isEmpty())) {
      this.setState({
        trimmedDataURL: this.signatureCanvas.getTrimmedCanvas()
          .toDataURL('image/png'),
      }, () => {
        const { trimmedDataURL } = this.state;
        const timestamp = moment().unix();
        const timestampUTC = moment().utcOffset();
        onUpdateSignature(FORM_KEYS.AGREEMENT.NDPF_PROPOSED_PLAN_SIGNATURE, trimmedDataURL);
        onUpdateTimestamp(timestamp, timestampUTC);
        onSaveApplicant(true);
        onSendEmail();
        onUpdateSteps(intl);
        onSubmitInit();

        this.setState({ isLoading: true });
        /** delay for 5 secs (to give time for the back to update data on generated PDFs) */
        setTimeout(() => {
          // history.push(PATH.PRINT_CHECKLIST);
          history.push(PATH.PAYMENT);
          this.setState({ isLoading: false });
        }, 5000);
      });
    } else {
      onSaveApplicant(true);
      if (isPageValid) {
        onSendEmail();
        onUpdateSteps(intl);
        this.setState({ isLoading: true });
        setTimeout(() => {
          // history.push(PATH.PRINT_CHECKLIST);
          history.push(PATH.PAYMENT);
          this.setState({ isLoading: false });
        }, 5000);
      }
    }

    // ADDED: history step 6
    onUpdateHistory(APPLICANT_HISTORY_CODE.SIGN_MAIN.code, APPLICANT_HISTORY_CODE.SIGN_MAIN.codeI18n);
    onUpdateHistory(APPLICANT_HISTORY_CODE.SIGN_PLAN.code, APPLICANT_HISTORY_CODE.SIGN_PLAN.codeI18n);
    onUpdateHistory(APPLICANT_HISTORY_CODE.SIGN_SUBA.code, APPLICANT_HISTORY_CODE.SIGN_SUBA.codeI18n);
  }

  render() {
    const { trimmedDataURL, isLoading, isCanvasEmpty } = this.state;
    const {
      history, intl, ndpf, proposedPlan,
      onAgreeWithAcknowledgement, onAgreeWithProposedPlan, signature,
      isSubmitClicked,
      allocationUrl, applicantId, imarkazRefCode, isShowSubcription, mftUrl,
      clientClassification, typeOfInvestment, investmentStrategies, assetAllocations,
      investmentStrategyUrl, investmentStrategyShariaUrl, assetAllocationUrl, irepUrl, dpfUrl, cpfUrl,
      product, customSubPfUrl, investmentStrategyDividendUrl,
      // dsUserDetail,
    } = this.props;
    const isPageValid = validation.contractSchema(intl, isShowSubcription).isValidSync({ ndpf, proposedPlan, ndpfProposedPlanSignature: signature });

    const isRetailClient = clientClassification === CLIENT_CLASSIFICATION.RETAIL;
    const isQualifiedClient = clientClassification === CLIENT_CLASSIFICATION.QUALIFIED;
    const isDiscretionary = typeOfInvestment === QUALIFIED_TYPE_OF_INVESTMENT.DISCRETIONARY;
    const isNonDiscretionary = typeOfInvestment === QUALIFIED_TYPE_OF_INVESTMENT.NON_DISCRETIONARY;
    const isShowDiscretionaryEquity = investmentStrategies.includes(INVESTMENT_STRATEGY.MENA_EQUITIES_ABSOLUTE);
    const isShowDiscretionaryEquitySharia = investmentStrategies.includes(INVESTMENT_STRATEGY.MENA_EQUITIES_ABSOLUTE_SHARIA);
    const isShowDiscretionaryDividendYield = investmentStrategies.includes(INVESTMENT_STRATEGY.DIVIDEND_YIELD);
    const isCustody = typeOfInvestment === QUALIFIED_TYPE_OF_INVESTMENT.CUSTODY;

    /** Refactored: Now using custom sub-pf  */
    const populateCustomFileUrlMenu = () => {
      const customMenu = [];
      // if (customFileUrls && customFileUrls.length) {
      //   customFileUrls.forEach(() => {
      //     customMenu.push('Sub Portfolio Agreement');
      //   });
      // }
      if (customSubPfUrl) customMenu.push('Sub Portfolio Agreement');
      return customMenu;
    };

    const discretionaryMenu = () => {
      const menu = [intl.formatMessage({ id: 'agreementMenu.DPF' })];
      if (isShowDiscretionaryEquity) menu.push(intl.formatMessage({ id: 'agreementMenu.menaEquitiesAbsolute' }));
      if (isShowDiscretionaryEquitySharia) menu.push(intl.formatMessage({ id: 'agreementMenu.menaEquitiesAbsoluteSharia' }));
      if (isShowDiscretionaryDividendYield) menu.push(intl.formatMessage({ id: 'agreementMenu.dividendYield' }));
      const mergedMenu = menu.concat(populateCustomFileUrlMenu());
      return mergedMenu;
    };

    /** Tab menu for NON-DISCRETIONARY Account */
    const nonDiscretionaryMenu = () => {
      const menu = [
        intl.formatMessage({ id: 'agreementMenu.NDPF' }),
        intl.formatMessage({ id: 'agreementMenu.subPortfolio' }),
        intl.formatMessage({ id: 'agreementMenu.assetAllocation' }),
      ];
      // if (customFileUrls && !customFileUrls.length) menu.push(intl.formatMessage({ id: 'agreementMenu.subPortfolio' }));
      // const mergedMenu = menu.concat(populateCustomFileUrlMenu());
      // mergedMenu.push(intl.formatMessage({ id: 'agreementMenu.assetAllocation' }));
      return menu;
    };

    /** Tab menu for Mutual Fund Subscription */
    const MFSMenu = (prodId) => {
      const menu = [intl.formatMessage({ id: 'agreementMenu.subscription' })];
      if (prodId === MUTUAL_FUND_SUBSCRIPTION.MUMTAZ) menu.push(intl.formatMessage({ id: 'clientDetails.markazMumtazFund' }));
      if (prodId === MUTUAL_FUND_SUBSCRIPTION.ISLAMIC) menu.push(intl.formatMessage({ id: 'clientDetails.markazIslamicFund' }));
      if (prodId === MUTUAL_FUND_SUBSCRIPTION.REAL_ESTATE) menu.push(intl.formatMessage({ id: 'clientDetails.markazRealEstateFund' }));
      return menu;
    };

    /** Tab menu for Qualified Account + Custody */
    const custodyMenu = () => {
      const menu = [intl.formatMessage({ id: 'agreementMenu.NDPF' })];
      const mergedMenu = menu.concat(populateCustomFileUrlMenu());
      return mergedMenu;
    };

    const getFactsheet = (prodId) => {
      switch (prodId) {
        case MUTUAL_FUND_SUBSCRIPTION.MUMTAZ:
          return `${factsheetUrl}/Mumtaz%20AOA.pdf`;
        case MUTUAL_FUND_SUBSCRIPTION.ISLAMIC:
          return `${factsheetUrl}/MIF%20AOA.pdf`;
        case MUTUAL_FUND_SUBSCRIPTION.REAL_ESTATE:
          return `${factsheetUrl}/MREF%20AOA.pdf`;
        default:
          return null;
      }
    };

    // const handleDisabled = () => (isShowSubcription ? !ndpf : !(proposedPlan && ndpf)) || isEmpty(signature) || isLoading;
    const handleDisabled = () => (isShowSubcription ? !ndpf : !(proposedPlan && ndpf)) || (isCanvasEmpty && !trimmedDataURL) || isLoading;

    const footer = (
      <FooterAction
        isSingleButton={false}
        leftButton={intl.formatMessage({ id: 'backToForms' })}
        onLeftButtonClick={() => history.push(`${PATH.PREVIEW}/crm`)}
        rightButton={isLoading ? <ReactLoading height="24px" width="24px" color="#ffffff" type="spin" /> : intl.formatMessage({ id: 'iAgree' })}
        onRightButtonClick={this.onSubmit}
        isDisabled={handleDisabled()}
        // isDisabled={!(proposedPlan && ndpf) || (isCanvasEmpty && !trimmedDataURL)}
      />
    );

    return (
      <>
        <PageContentWrapper isWithPadding isWithHeader>
          <div className="content-container">
            {/* RETAIL WITH IMARKAZ PORTFOLIO AND NO REFCODE */}
            {isRetailClient && typeOfInvestment === TYPE_OF_INVESTMENT.IMARKAZ_PORTFOLIO && !imarkazRefCode && (
              <TabsMenu
                menu={[intl.formatMessage({ id: 'agreementMenu.NDPF' }), intl.formatMessage({ id: 'agreementMenu.subPortfolio' })]}
              >
                <NDPF applicantId={applicantId} />
                <SubPortfolio applicantId={applicantId} />
              </TabsMenu>
            )}

            {/* RETAIL WITH IMARKAZ PORTFOLIO AND REFCODE */}
            {isRetailClient && typeOfInvestment === TYPE_OF_INVESTMENT.IMARKAZ_PORTFOLIO && imarkazRefCode && (
            <TabsMenu
              menu={[intl.formatMessage({ id: 'agreementMenu.NDPF' }), intl.formatMessage({ id: 'agreementMenu.subPortfolio' }), intl.formatMessage({ id: 'agreementMenu.proposedAllocation' })]}
            >
              <NDPF applicantId={applicantId} />
              <SubPortfolio applicantId={applicantId} />
              <PDFViewer url={allocationUrl} />
            </TabsMenu>
            )}

            {/* MUTUAL FUND SUBSCRIPTION (FOR RETAIL & QUALIFIED) */}
            {isShowSubcription && (
              <TabsMenu
                menu={MFSMenu(product)}
              >
                <PDFViewer url={mftUrl} />
                <PDFViewer url={getFactsheet(product)} />
              </TabsMenu>
            )}

            {/* QUALIFIED NON DISCRETIONARY WITH UPLOADED IMARKAZ PORTFOLIO */}
            {isQualifiedClient && isNonDiscretionary && assetAllocations === ASSET_ALLOCATIONS.IMARKAZ_PORTFOLIO && (
              <TabsMenu
                // menu={[intl.formatMessage({ id: 'agreementMenu.NDPF' }), intl.formatMessage({ id: 'agreementMenu.subPortfolio' }), intl.formatMessage({ id: 'agreementMenu.assetAllocation' })]}
                menu={nonDiscretionaryMenu()}
              >
                <NDPF applicantId={applicantId} />

                {/* Show custom uploaded sub agreement if available otherwise, show the existing sub agreement */}
                {customSubPfUrl ? <PDFViewer url={customSubPfUrl} /> : <SubPortfolio applicantId={applicantId} />}

                {/* Show custom uploaded asset allocation if available otherwise, display generated iMarkaz asset allocation */}
                {assetAllocationUrl ? <PDFViewer url={assetAllocationUrl} /> : <PDFViewer url={allocationUrl} />}
              </TabsMenu>
            )}

            {/* QUALIFIED NON DISCRETIONARY WITH IREP  */}
            {isQualifiedClient && isNonDiscretionary && assetAllocations === ASSET_ALLOCATIONS.INTERNATIONAL_REAL_ESTATE_PRODUCTS && (
            <TabsMenu
              menu={nonDiscretionaryMenu()}
            >
              <NDPF applicantId={applicantId} />

              {/* Show custom uploaded sub agreement if available otherwise, show the existing sub agreement (irepUrl) */}
              {customSubPfUrl ? <PDFViewer url={customSubPfUrl} /> : <PDFViewer url={irepUrl} />}

              <PDFViewer url={assetAllocationUrl} />

            </TabsMenu>
            )}

            {/* DISCREATIONARY WITH MENA EQUITIES ABSOLUTE */}
            {isQualifiedClient && isDiscretionary && isShowDiscretionaryEquity && !isShowDiscretionaryEquitySharia && !isShowDiscretionaryDividendYield && (
              <TabsMenu
                menu={discretionaryMenu()}
              >
                <PDFViewer url={dpfUrl} />

                <PDFViewer url={investmentStrategyUrl} />

                {/* Uploaded Custom sub agreement/portfolio */}
                {customSubPfUrl && <PDFViewer url={customSubPfUrl} />}
                {/* {customFileUrls && customFileUrls.length && customFileUrls.map((item, i) => (
                  <PDFViewer key={`custom-file-${i}`} url={item} />
                ))} */}
              </TabsMenu>
            )}

            {/* DISCREATIONARY WITH MENA EQUITIES ABSOLUTE SHARIA */}
            {isQualifiedClient && isDiscretionary && !isShowDiscretionaryEquity && isShowDiscretionaryEquitySharia && !isShowDiscretionaryDividendYield && (
              <TabsMenu
                menu={discretionaryMenu()}
              >
                <PDFViewer url={dpfUrl} />

                <PDFViewer url={investmentStrategyShariaUrl} />
                {/* Uploaded Custom sub agreements/ files */}
                {customSubPfUrl && <PDFViewer url={customSubPfUrl} />}
                {/* {customFileUrls && customFileUrls.length && customFileUrls.map((item, i) => (
                  <PDFViewer key={`custom-file-${i}`} url={item} />
                ))} */}
              </TabsMenu>
            )}

            {/* DISCREATIONARY WITH DIVIDEND YIELD */}
            {isQualifiedClient && isDiscretionary && isShowDiscretionaryDividendYield && !isShowDiscretionaryEquity && !isShowDiscretionaryEquitySharia && (
              <TabsMenu
                menu={discretionaryMenu()}
              >
                <PDFViewer url={dpfUrl} />

                <PDFViewer url={investmentStrategyDividendUrl} />
                {/* Uploaded Custom sub agreements/ files */}
                {customSubPfUrl && <PDFViewer url={customSubPfUrl} />}

              </TabsMenu>
            )}

            {/* DISCREATIONARY WITH BOTH MENA EQUITIES ABSOLUTE & MENA EQUITIES ABSOLUTE SHARIA */}
            {isQualifiedClient && isDiscretionary && isShowDiscretionaryEquity && isShowDiscretionaryEquitySharia && !isShowDiscretionaryDividendYield && (
              <TabsMenu
                menu={discretionaryMenu()}
              >
                <PDFViewer url={dpfUrl} />

                <PDFViewer url={investmentStrategyUrl} />
                <PDFViewer url={investmentStrategyShariaUrl} />

                {/* Uploaded Custom sub agreements/ files */}
                {customSubPfUrl && <PDFViewer url={customSubPfUrl} />}
              </TabsMenu>
            )}

            {/* DISCREATIONARY WITH BOTH MENA EQUITIES ABSOLUTE, MENA EQUITIES ABSOLUTE SHARIA & DIVIDEND YIELDS */}
            {isQualifiedClient && isDiscretionary && isShowDiscretionaryEquity && isShowDiscretionaryEquitySharia && isShowDiscretionaryDividendYield && (
              <TabsMenu
                menu={discretionaryMenu()}
              >
                <PDFViewer url={dpfUrl} />

                <PDFViewer url={investmentStrategyUrl} />
                <PDFViewer url={investmentStrategyShariaUrl} />
                <PDFViewer url={investmentStrategyDividendUrl} />

                {/* Uploaded Custom sub agreements/ files */}
                {customSubPfUrl && <PDFViewer url={customSubPfUrl} />}
              </TabsMenu>
            )}

            {isQualifiedClient && isCustody && (
              <TabsMenu
                menu={custodyMenu()}
              >
                <PDFViewer url={cpfUrl} />

                {/* Uploaded Custom sub agreements/portfolio */}
                {customSubPfUrl && <PDFViewer url={customSubPfUrl} />}
              </TabsMenu>
            )}

            <FormElementContainer isWithPadding>
              <Label label={intl.formatMessage({ id: 'agreement.aknowledgement' })} />

              <CheckMarkBool
                id="NDPF-AGREEMENT"
                name="ndpfAgreement"
                label={intl.formatMessage({ id: 'agreement.ndpf' })}
                isChecked={ndpf}
                onCheckMarkChange={onAgreeWithAcknowledgement}
              />
            </FormElementContainer>

            {!isShowSubcription && (
              <FormElementContainer isWithPadding>
                <Label label={intl.formatMessage({ id: 'agreement.proposedAllocactionPlan' })} />
                <CheckMarkBool
                  id="PROPOSED-AGREEMENT"
                  name="proposedPlanAgreement"
                  label={intl.formatMessage({ id: 'agreement.proposedPlan' })}
                  isChecked={proposedPlan}
                  onCheckMarkChange={onAgreeWithProposedPlan}
                />
              </FormElementContainer>
            )}

            <FormElementContainer isWithPadding customClass="withButton">
              <Label label={intl.formatMessage({ id: 'agreements.digitalSignature' })} />
              <p style={{ marginTop: 'unset' }}><small><em>{intl.formatMessage({ id: 'digital.signature.info2' })}</em></small></p>

              {/* {this.state.page === 'welcome' && !signature ? (
                <div>
                  {this.state.isLoggingInToDocuSign ? (
                    <div className="docuSign-status">
                      <ReactLoading height="24px" width="24px" color="#47B7F5" type="spin" />
                      <span>{intl.formatMessage({ id: 'docuSign.loggingIn' })}</span>
                    </div>
                  ) : <Button isTertiary isFullWidth value={intl.formatMessage({ id: 'docuSign.login' })} onButtonClick={this.startAuthentication} />}
                </div>
              ) : (
                <>
                  {(!this.state.isSendingDocForSigning && !this.state.isWaitingForSignature) && !signature ? (
                    <Button isTertiary isFullWidth value={intl.formatMessage({ id: 'docuSign.signAgreement2' })} isDisabled={isShowSubcription ? !ndpf : !(proposedPlan && ndpf)} onButtonClick={this.sendEnvelope} />
                  ) : null}
                  {this.state.isSendingDocForSigning && !isPageValid ? (
                    <div className="docuSign-status">
                      <ReactLoading height="24px" width="24px" color="#47B7F5" type="spin" />
                      <span>{intl.formatMessage({ id: 'docuSign.processing' })}</span>
                    </div>
                  ) : null}
                  {this.state.isWaitingForSignature ? (
                    <div className="docuSign-status">
                      <ReactLoading height="24px" width="24px" color="#47B7F5" type="spin" />
                      <span>{intl.formatMessage({ id: 'docuSign.waiting' })}</span>
                    </div>
                  ) : null}
                </>
              )} */}

              {/* {isPageValid || signature ? (
                <div className="docuSign-status">
                  <span className="docuSign-status__completed">{intl.formatMessage({ id: 'docuSign.complete' })}</span>
                </div>
              ) : null} */}

              {!trimmedDataURL && (
              <>
                <SignatureCanvas
                  onEnd={() => this.setState({ isCanvasEmpty: this.signatureCanvas.isEmpty() })}
                  penColor="black"
                  canvasProps={{ width: isMobileOnly ? 400 : 861, height: 200, className: 'sigCanvas' }}
                  backgroundColor={isMobileOnly ? 'white' : '#f4f4f4'}
                  ref={(ref) => { this.signatureCanvas = ref; }}
                />
                <Button isTertiary isOutlineButton isSmall onButtonClick={this.clearSignature} value={intl.formatMessage({ id: 'clear' })} />
              </>
              )}

              {trimmedDataURL
                ? (
                  <>
                    <img
                      src={trimmedDataURL}
                      alt="signature"
                    />
                    <Button isTertiary isOutlineButton isSmall onButtonClick={this.redoSignature} value={intl.formatMessage({ id: 'redo' })} />
                  </>
                )
                : null}

              {!isPageValid && isSubmitClicked && <span className="notification notification--error">{intl.formatMessage({ id: 'validation.signature' })}</span>}
            </FormElementContainer>

          </div>
          {!isMobileOnly && footer}
        </PageContentWrapper>
        {isMobileOnly && footer}
      </>
    );
  }
}

const mapStateToProps = state => ({
  ndpf: selectors.getAcknowledgementAgreement(state),
  proposedPlan: selectors.getProposedPlanAgreement(state),
  signature: selectors.getNdpfProposedPlanSignature(state),
  isSubmitClicked: selectors.getIsFormSubmitted(state),
  allocationUrl: state.applicantRootReducer.applicantReducer.allocationUrl,
  mftUrl: state.applicantRootReducer.applicantReducer.mftUrl,
  applicantId: state.applicantRootReducer.applicantReducer.applicantId,
  imarkazRefCode: state.applicantRootReducer.applicantReducer.imarkazRefCode,
  isAllStepsCompleted: selectors.isAllStepsCompleted(state),
  isShowSubcription: selectors.isShowSubcription(state),
  investmentStrategies: selectors.getInvestmentStrategy(state),
  assetAllocations: selectors.getAssetAllocation(state),
  product: selectors.getProduct(state),
  ndpfProposedPlanTimestamp: state.agreementReducer.ndpfProposedPlanTimestamp,

  clientClassification: selectors.getClientClassification(state),
  typeOfInvestment: selectors.getTypeOfInvestment(state),
  assetAllocationUrl: selectors.getAssetAllocationUrl(state),
  irepUrl: selectors.getIrepUrl(state),
  dpfUrl: selectors.getDpfUrl(state),
  cpfUrl: selectors.getCpfUrl(state),
  customFileUrls: selectors.getCustomUploadedFileUrls(state),
  customSubPfUrl: selectors.getCustomSubPfUrl(state),
  investmentStrategyUrl: selectors.getinvestmentStategyAbsoluteUrl(state),
  investmentStrategyShariaUrl: selectors.getinvestmentStategyAbsoluteShariaUrl(state),
  investmentStrategyDividendUrl: selectors.getinvestmentStategyDividend(state),
  formSignature: selectors.getAofKycProfileSignature(state),

  isAgreementReadyForQualified: selectors.getIsAgreementReadyStatus(state),
  isCustomAssetAllocationUploaded: selectors.getIsCustomAAUploaded(state),

  dsUserDetail: selectors.getDsUserDetail(state),
  phoneNumber: selectors.getPhoneNumber(state),
  token: selectors.getToken(state),
});

const mapDispatchToProps = dispatch => ({
  onUpdateCurrentStep: currentStep => dispatch(stepAction.updateCurrentStep(currentStep)),
  onUpdateSteps: intl => dispatch(stepAction.updateSteps(intl)),
  onAgreeWithAcknowledgement: () => dispatch(agreementAction.toggleAcknowledgementUndertaking()),
  onAgreeWithProposedPlan: () => dispatch(agreementAction.toggleProposedPlan()),
  onSaveApplicant: (isGenerate, isSigned) => dispatch(applicantAction.updateApplicant(isGenerate, isSigned)),
  onUpdateSignature: (name, value) => dispatch(agreementAction.updateSignature(name, value)),
  onUpdateTimestamp: (timestamp, timestampUTC) => dispatch(agreementAction.updateNdpfProposedPlanTimestamp(timestamp, timestampUTC)),
  onSendEmail: () => dispatch(applicantAction.sendApplicationToEmail()),
  onUpdateHistory: (code, codeI18n) => dispatch(applicantAction.updateHistory(code, codeI18n)),
  onLoadProposedAllocationPlan: () => dispatch(agreementAction.loadProposedAllocationPlan()),
  onLoadSubcription: () => dispatch(agreementAction.loadSubcription()),
  onLoadAssetAllocationPDf: () => dispatch(agreementAction.getAssetAllocationPDF()),
  onLoadInvestmentStrategyPDFs: () => dispatch(agreementAction.getInvestmentStategyPDFs()),
  onLoadIrepPDF: () => dispatch(agreementAction.getInternationRealEstateProductsPDF()),
  onLoadCpfPDF: () => dispatch(agreementAction.generateCustodyContract()),
  onLoadCustomSubPfPDF: () => dispatch(applicantAction.getCustomSubPfPdf()),
  // onLoadDividendPDF: () => dispatch(agreementAction.getDividendYieldPDF()),
  // onLoadAllCustomUploadedFiles: () => dispatch(applicantAction.getCustomFilePdfs()), // @Todo remove once custom sub-pf is working
  onGetAgreementStatus: () => dispatch(agreementAction.getQualifiedAgreementStatus()),

  onSubmitClick: () => dispatch(submitClicked()),
  onSubmitInit: () => dispatch(submitInit()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutWithStepper(injectIntl(Agreement)));
